"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _helpers = require("../../helpers");

var _components = require("../../components");

var _styles = _interopRequireDefault(require("./styles"));

var Root = _styles["default"].Root,
    Row = _styles["default"].Row,
    Column = _styles["default"].Column,
    SupplierImages = _styles["default"].SupplierImages,
    Card = _styles["default"].Card;

var SearchSelect = function SearchSelect(props) {
  var config = props.config,
      onChoiceSelect = props.onChoiceSelect,
      env = props.env,
      mobile = props.mobile,
      suppliers = props.suppliers;
  return /*#__PURE__*/_react["default"].createElement(Root, {
    className: "home-root",
    mobile: mobile
  }, /*#__PURE__*/_react["default"].createElement(Row, {
    className: "availibility-stores"
  }, /*#__PURE__*/_react["default"].createElement(Column, {
    className: "center",
    width: mobile ? '100%' : '60%',
    height: "fit-content"
  }, /*#__PURE__*/_react["default"].createElement(_components.Title, {
    imageUrl: config.iconUrl,
    title: config.title,
    mobile: mobile,
    blobUrl: env.blobUrl
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "search-selections",
    "data-aurora-automation": "store-search-categories-container"
  }, config.categories.map(function (choice, i) {
    return /*#__PURE__*/_react["default"].createElement(Card, {
      className: "search-card",
      "data-aurora-automation": "store-search-category",
      key: i,
      height: "7.5rem",
      width: mobile ? '100%' : '16.875rem',
      onClick: function onClick() {
        return onChoiceSelect(choice.name);
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "card-container"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      alt: "image-choice",
      src: choice.imageUrl
    }), /*#__PURE__*/_react["default"].createElement("h4", null, choice.name)));
  })), !mobile && /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement("h4", null, config.tagLine), /*#__PURE__*/_react["default"].createElement(SupplierImages, {
    "data-aurora-automation": "store-supplier-logos-container"
  }, suppliers && suppliers.map(function (supplier, i) {
    return /*#__PURE__*/_react["default"].createElement("img", {
      alt: "supplier-image ".concat(supplier.name),
      src: env.blobUrl + '/' + supplier.SquareLogo,
      className: "supplier-image ".concat(supplier.name, " fade-in"),
      "data-aurora-automation": "store-supplier-logo",
      key: i
    });
  }))))));
};

var _default = SearchSelect;
exports["default"] = _default;